import { useEventDataOfSelectedEvent } from "@Utils/event";
import { isInstallmentsPlanType } from "repoV2/utils/common/listing";
import { useInstalmentsDetailsContext } from "../utils/InstalmentsDetailsContext";
import { IPaymentPlan } from "../IPaymentPlan";

/**
 * @description use this hook in old event page to decide whether to show or hide the `PaymentPlan` component
 */
export const useHidePaymentPlan = ({
    paymentSummaryProps,
}: IPaymentPlan.IProps) => {
    const { disablePayment } = paymentSummaryProps || {};

    const { eventData } = useEventDataOfSelectedEvent();
    const { showInstallmentsPlan } = useInstalmentsDetailsContext();
    const { payment_plan_type } = eventData || {};
    const hasInstalments = isInstallmentsPlanType(payment_plan_type);

    return disablePayment || !hasInstalments || !showInstallmentsPlan;
};
